import styled from "styled-components";

export const Container = styled.div`
  .MuiInputBase-root {
    font-family: Poppins, sans-serif;
  }
`;
